var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuotationLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 50,
    viewBox: "0 0 61 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9528 40.634C36.2547 38.8088 38.4607 36.3593 40.5708 33.2853C42.5849 30.2113 44.1195 26.9933 45.1745 23.6311C44.7909 23.7272 44.2634 23.7752 43.592 23.7752C41.0024 23.7752 38.7964 22.7666 36.9741 20.7493C35.0558 18.732 34.0967 16.0903 34.0967 12.8242C34.0967 8.98175 35.3915 5.85975 37.9811 3.45821C40.4748 1.15274 43.6879 2.64116e-06 47.6203 2.98547e-06C51.6486 3.33819e-06 54.9096 1.3929 57.4033 4.17868C59.8011 7.06052 61 10.8069 61 15.4179C61 21.4697 59.2736 27.7137 55.8208 34.1499C52.3679 40.586 47.8121 45.8694 42.1533 50L33.9528 40.634ZM9.63915 23.7752C6.95362 23.7752 4.69969 22.7666 2.87736 20.7493C1.05503 18.732 0.143868 16.0903 0.143868 12.8242C0.143869 8.98175 1.39073 5.85975 3.88444 3.45821C6.37815 1.15274 9.5912 -3.44316e-07 13.5236 0C17.5519 3.52714e-07 20.8129 1.39289 23.3066 4.17868C25.8003 7.06052 27.0472 10.8069 27.0472 15.4179C27.0472 21.3737 25.3208 27.5696 21.8679 34.0058C18.3192 40.5379 13.7634 45.8694 8.20047 50L0 40.634C2.30189 38.7128 4.50786 36.2152 6.61793 33.1412C8.63208 30.1633 10.1187 26.9933 11.0778 23.6311C10.7901 23.7272 10.3105 23.7752 9.63915 23.7752Z",
    fill: "#367FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuotationLarge);
export default __webpack_public_path__ + "static/media/icon-quotation-large.ae9b59e082329c06240f551b6fedf3e1.svg";
export { ForwardRef as ReactComponent };